import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Card, CardSection } from "cxa-components";
import HDFComponent from "./HDFComponent";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { HdfDataContext } from "../index";
import humps from "humps";

const DependantParticulars = ({
  label,
  hideLabel,
  isNarrowScreen,
  columns,
  collapsible,
  components,
  id,
  ...props
}) => {
  const members = useContext(HdfDataContext).eligibleMembers || [];
  const dependantList = members.filter(member => member.type !== "Employee");
  return dependantList.map(dependant => {
    return (
      <Card key={`${id}${dependant.relationshipDetail}`} className="hdf-card">
        <CardSection>
          {!hideLabel && (
            <div className="section-header">
              <strong>{label}</strong>
            </div>
          )}
          <div
            className="grid-container"
            style={{ gridTemplateColumns: `repeat(${isNarrowScreen ? 1 : columns}, 1fr)` }}
          >
            {components &&
              components.map(comp => {
                return (
                  <HDFComponent
                    key={comp.id}
                    name={`${humps.camelize(dependant.relationshipDetail)}_${comp.id}`}
                    comp={comp}
                    {...props}
                  />
                );
              })}
          </div>
        </CardSection>
      </Card>
    );
  });
};

DependantParticulars.propTypes = {
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  isNarrowScreen: PropTypes.bool,
  collapsible: PropTypes.bool,
  columns: PropTypes.number,
  components: PropTypes.array,
  dependents: PropTypes.array,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(DependantParticulars);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/DependantParticulars.js